import Flex from '@/components/common/Flex';
import { FiArrowUpCircle, FiArrowDownCircle, FiCircle } from 'react-icons/fi';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { getColor } from '@/helpers/utils';
import countSuffix from '@/helpers/countSuffix';
import { useAppContext } from '@/Main';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import type { MouseEvent } from 'react';
import { showDrawer } from '@/app/common/reducers/drawer';
import type { ChecklistItemData } from './checklistTypes';

interface ChecklistItemProps {
  data: ChecklistItemData[];
  searchText?: string;
  color?: string;
}

const ChecklistItem = ({
  data,
  searchText
}: ChecklistItemProps): React.JSX.Element => {
  const {
    config: { isRTL }
  } = useAppContext();
  const dispatch = useDispatch();
  const convertModeToEn = (text: string): string | undefined => {
    switch (text) {
      case 'خطا':
        return 'error';
      case 'هشدار':
        return 'warning';
      case 'اطلاعیه':
        return 'info';
    }
  };
  const convertPriorityToEn = (text: string): string | undefined => {
    switch (text) {
      case 'بالا':
        return 'high';
      case 'متوسط':
        return 'medium';
      case 'پایین':
        return 'low';
    }
  };
  // آیتم های استفاده شده در کارت های فهرست بازبینی
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const handleSearch = (
    text: string | undefined,
    item: ChecklistItemData
  ): boolean | undefined => {
    if (text) {
      const normalizedText = text.toLowerCase();
      const mode = convertModeToEn(normalizedText);
      const priority = convertPriorityToEn(normalizedText);
      return Boolean(
        item.show_title?.toLowerCase().includes(normalizedText) ||
          item.gp?.toLowerCase().includes(normalizedText) ||
          (mode && item.mode?.toLowerCase().includes(mode)) ||
          (priority && item.priority?.toLowerCase().includes(priority))
      );
    }
  };
  return (
    <>
      {/* لینک برای گزینه های فهرست بازبینی */}
      {data.map((item, index) => (
        <Flex
          alignItems="baseline"
          justifyContent="between"
          key={index}
          className={`fs--1  gap-2 ${index == 0 && 'mt-3'}`}
        >
          <h6
            className={`mb-1 ${
              handleSearch(searchText, item) ? 'bg-300' : ''
            } ${
              item.link === searchParams.get('issues')
                ? 'fw-bold text-primary'
                : 'text-700'
            }`}
          >
            <Link
              className="text-decoration-none text-reset hover-800"
              to={`${pathname}?issues=${item.link}`}
              // className={item.count === 0 ? 'disabled-link' : ''}
              state={{ path: `${pathname}`, query: searchParams.get('issues') }}
            >
              <span className="check-list-item">
                {/* آیکون های کناری گزینه های فهرست بازبینی */}
                {item.priority == 'high' ? (
                  <FiArrowUpCircle
                    title="اولویت بالا"
                    color={getColor('danger')}
                  />
                ) : item.priority == 'medium' ? (
                  <FiCircle
                    title="اولویت متوسط"
                    color={getColor('warning')}
                  />
                ) : (
                  <FiArrowDownCircle
                    title="اولویت پایین"
                    color={getColor('info')}
                  />
                )}{' '}
                {item.show_title}
              </span>
            </Link>

            <FontAwesomeIcon
              icon={['far', 'question-circle']}
              transform="shrink-1"
              style={{
                transform: isRTL ? 'scaleX(-1)' : 'scaleX(1)',
                pointerEvents: 'all'
              }}
              className={`ms-1 text-400 cursor-pointer check-list-item`}
              id="weeklySalesTooltip"
              onClick={(event: MouseEvent<SVGSVGElement>) => {
                event.stopPropagation();
                event.preventDefault();

                dispatch(
                  showDrawer({
                    key: 'help',
                    payload: {
                      slug: item.link,
                      title: item.show_title,
                      tooltip: item.tooltip
                    }
                  })
                );
              }}
            />
          </h6>

          <h6
            className={
              item.link === searchParams.get('issues')
                ? 'fw-bold text-primary'
                : 'text-700'
            }
          >
            {countSuffix(item.count)}
          </h6>
        </Flex>
      ))}
    </>
  );
};

export default ChecklistItem;
